
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tidal-dashboard/webhooks",
      function () {
        return require("private-next-pages/tidal-dashboard/webhooks/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tidal-dashboard/webhooks"])
      });
    }
  